<div (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  [ngClass]="{'map-control-expended' : controlExpended}"
  class="map-control"
  id="markers-control">
  <div class="map-control-icon mdi mdi-map-marker-multiple sm"></div>
  <div class="map-control-content">
    @if (shouldDisplayMapMarkers()) {
      <label>{{'LABEL.MARKERS' | translate}}</label>
      <mat-radio-group (change)="onRadioChange($event)" class="fx-layout-col">
        @for (assetMapMarkerGroup of assetMapMarkerGroups; track assetMapMarkerGroup) {
          <mat-radio-button
            [value]="assetMapMarkerGroup"
            [checked]="assetMapMarkerGroup === selectedMapMarkerGroup">
            {{ 'LAYER.' + assetMapMarkerGroup.name.toUpperCase() | translate }}
          </mat-radio-button>
        }
      </mat-radio-group>
      <mat-divider></mat-divider>
    }

    <label>{{'TITLE.GROUPING_MARKERS' | translate}}</label>
    <div class="fx-layout-row fx-gap-10-percent">
      <mat-slide-toggle (change)="onSlideToggleChange($event)" [checked]="groupedMarkersEnable"></mat-slide-toggle>
      @if (groupedMarkersEnable) {
        <mat-label>{{'LABEL.ACTIVATED' | translate}}</mat-label>
      }
      @if (!groupedMarkersEnable) {
        <mat-label>{{'LABEL.DEACTIVATED' | translate}}</mat-label>
      }
    </div>
  </div>
</div>
